var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.778 19.78h10V9.797h-10zm-5.556 0h3.334V9.797H4.222zm0-12.228h15.556V4.221H4.222zM4 2C2.896 2 2 3.057 2 4.36v15.28C2 20.943 2.896 22 4 22h16c1.104 0 2-1.057 2-2.36V4.36C22 3.057 21.104 2 20 2z"
})));
export default SvgGemView;